Vue.component('articles-page', require('./../components/articles/ArticlesPage').default);